var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPinLightFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1534",
    "data-name": "Path 1534",
    d: "M12,784.32a.546.546,0,0,0-.16-.386l-3.066-3.066a.546.546,0,0,0-.771,0l-4.009,4.009a3.5,3.5,0,0,0-3.834.462.545.545,0,0,0,0,.771l2.833,2.833L.449,791.489a.545.545,0,0,0,.771.771l2.545-2.545L6.6,792.549a.546.546,0,0,0,.771,0,3.5,3.5,0,0,0,.462-3.834l4.009-4.009a.546.546,0,0,0,.16-.386",
    transform: "translate(-0.001 -780.709)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPinLightFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pin_light_filled.32a46edc371d0e6de1d570c381e32d9e.svg";